export default __webpack_public_path__ + "BetConstruct-Icons-d08b5855.woff";